<form >
    <div class="row">
        <div class="col-sm-4">
            <div class="mb-3">
                <label class="form-label">name in arabic</label>
                <input type="text" class="form-control" placeholder="name in arabic" [(ngModel)]="formData.name_ar" name="name_ar" required>
            </div>
        </div><!-- Col -->
    </div><!-- Row -->

    <div class="row">
        <div class="col-sm-4"> 
            <div class="mb-3">
                <label class="form-label">name in english</label>
                <input type="text" class="form-control" placeholder="name in english" [(ngModel)]="formData.name_en" name="name_en" required>
            </div>
        </div><!-- Col -->

        <div class="col-sm-4">
            <div class="mb-3">
                <label class="form-label">code</label>
                <input type="text" class="form-control" placeholder="CODE" [(ngModel)]="formData.code" name="code" required>
            </div>
        </div><!-- Col -->
    </div><!-- Row -->

    <div class="row">
        <div class="col-sm-4">
            <div class="mb-3">
                <label class="form-label">mobile code</label>
                <input type="text" class="form-control" placeholder="mobile code" [(ngModel)]="formData.mobile_code" name="mobile_code" required>
            </div>
        </div><!-- Col -->

        <div class="col-sm-4">
            <div class="mb-3">
              <label for="exampleInputImage" class="form-label">image</label>
              <input type="file" class="form-control" id="exampleInputImage" (change)="onFileSelected($event)" 
              accept="image/*" name="image" autocomplete="off">


            </div>
          </div><!-- Col -->
    </div><!-- Row -->

    

    <div class="row">
        <div class="col-sm-4">
            <div class="mb-3 d-flex justify-content-between">
                <button type="submit" class="btn btn-primary">ADD LANGUAGE LIGHT</button>
                <!-- <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button> -->

                <!-- <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button> -->
            </div>
        </div><!-- Col -->
    </div><!-- Row -->
</form>